import { Component, OnInit, Injector } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';
import { callNextAsync } from '../../services/BaseService';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment";

@Component({
  selector: 'app-date-selector',
  template: require('./date-selector.component.html'),
  styles: [require('./date-selector.component.scss')]
})
export class DateSelectorComponent  extends AppComponentBase  implements OnInit {

  constructor( injector: Injector, public parserFormatter: NgbDateParserFormatter) {
    super(injector);
   }

  ngOnInit() {
  }



  public filters:dateFilters[] = [ 
    {value:"all", label:"ALL"},
    {value:"today", label:"Today"},
    {value:"3d", label:"Last 3 Days"},
    {value:"lastweek", label:"Last Week"},
    {value:"custom", label:"Custom"},
  ]


  //private _currentValue: string = this.workspace.dateFilterType;
  public get currentValue (): string {
    return this.workspace.dateFilterType;
  }
  public set currentValue ( value: string ) {
   // callNextAsync(this.globaGridMode.dateFilter, value)
    if(value !="custom")
    {
      this.ShowDateRangeError = false
    }
    else
    {
        this.workspace.toDateFilter = undefined;
        this.workspace.fromDateFilter = undefined;
        this.workspace.pdfReportHistoryDateRange.from = undefined;
        this.workspace.pdfReportHistoryDateRange.to = undefined;
    }

    this.workspace.dateFilterType = value;
    this.workspace.globaGridMode.dateFilter.next(value);
  }


  private _fromDate: NgbDateStruct | any;
  public get fromDate (): NgbDateStruct | any {
    return this.workspace.fromDateFilter;
  }
  public set fromDate ( value: NgbDateStruct | any ) {

    
    this.workspace.fromDateFilter = value 
   // this.parserFormatter.format(value);

    //console.log(this.parserFormatter.format(value));
    let fromDate = moment(this.parserFormatter.format(this.workspace.fromDateFilter), 'YYYY-MM-DD');
    let toDate = moment(this.parserFormatter.format(this.workspace.toDateFilter), 'YYYY-MM-DD');

    if(toDate.isBefore(fromDate))
    {
      this.ShowDateRangeError = true;
    }
    else
    {
      this.ShowDateRangeError = false
    }


    this.globaGridMode.dateFilter.next(value);
  }

  private _toDate: NgbDateStruct | any;
  public get toDate (): NgbDateStruct | any {
    return this.workspace.toDateFilter;
  }
  public set toDate ( value: NgbDateStruct | any ) {

   
    this.workspace.toDateFilter = value;

    let fromDate = moment(this.parserFormatter.format(this.workspace.fromDateFilter), 'YYYY-MM-DD');
    let toDate = moment(this.parserFormatter.format(this.workspace.toDateFilter), 'YYYY-MM-DD');

    if(toDate.isBefore(fromDate))
    {
      this.ShowDateRangeError = true;
    }
    else
    {
      this.ShowDateRangeError = false
    }
    // this.parserFormatter.format(value);
    callNextAsync(this.globaGridMode.dateFilter,value);

  }

  private _ShowDateRangeError: boolean = false;
  public get ShowDateRangeError (): boolean {


   

    return this._ShowDateRangeError;
  }
  public set ShowDateRangeError ( value: boolean ) {
    this._ShowDateRangeError = value;
  }



}

export interface dateFilters{
  value:string,
  label:string
}


// export enum dateFilterTypes
// {
//   ALL =  "all",
//   TODAY =  "today"
// }